import { GridColDef } from "@mui/x-data-grid";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import TimelineIcon from "@mui/icons-material/Timeline";

export const ticketFeedColumns: GridColDef[] = [
  {
    field: "eventName",
    headerName: "Event",
    width: 300,
    sortable: false,
    renderCell: (params) => (
      <div
        style={{
          position: "relative",
          width: "100%",
        }}
      >
        <span
          style={{
            display: "inline-block",
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {params.value}
        </span>
      </div>
    ),
  },
  { field: "location", headerName: "Venue", width: 200, sortable: false },
  {
    field: "city",
    headerName: "City",
    width: 120,
    sortable: false,
    renderCell: (params) =>
      params.value &&
      params.value !== null &&
      params.value !== undefined &&
      params.value !== ""
        ? params.value
        : "-",
  },
  {
    field: "eventDate",
    headerName: "Date",
    width: 130,
    renderCell: (params) => {
      if (!params.value) return "";
      const d = new Date(params.value);
      if (isNaN(d.getTime())) return params.value;
      return d.toISOString().slice(0, 10);
    },
    sortable: false,
  },
  {
    field: "lowestPrice",
    headerName: "Get-in Price",
    width: 130,
    sortable: false,
    renderCell: (params) =>
      params.value !== undefined && params.value !== null
        ? `$${Number(params.value).toFixed(2)}`
        : "N/A",
  },
  {
    field: "thirtyDayPrice",
    headerName: "30d Low Price",
    width: 160,
    sortable: false,
    renderHeader: () => (
      <span
        style={{
          fontWeight: 500,
          fontSize: "1.05rem",
          letterSpacing: "0.03em",
          color: "white",
          display: "flex",
          alignItems: "center",
        }}
      >
        30d Low Price
        <Tooltip
          title={
            <span style={{ fontSize: "0.8rem" }}>
              Lowest get-in price seen in the last 30 days
            </span>
          }
          arrow
        >
          <InfoOutlinedIcon
            fontSize="small"
            sx={{ verticalAlign: "middle", color: "#AEE2FF", ml: 0.5 }}
          />
        </Tooltip>
      </span>
    ),
    renderCell: (params) => (
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <span
          style={{
            display: "inline-block",
            maxWidth: "calc(100% - 28px)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {params.value !== undefined && params.value !== null
            ? `$${Number(params.value).toFixed(2)}`
            : "N/A"}
        </span>
        <TimelineIcon
          fontSize="small"
          sx={{
            color: "#4A9EFF",
            ml: 15,
            position: "absolute",
            pointerEvents: "none",
          }}
        />
      </div>
    ),
  },
  {
    field: "url",
    headerName: "View Event",
    width: 130,
    renderCell: (params) =>
      params.value ? (
        <a
          href={params.value}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#4A9EFF" }}
        >
          VividSeats
        </a>
      ) : (
        ""
      ),
    sortable: false,
  },
];
